export default __webpack_public_path__ + "static/Couture-Regular-e4d6db9efe28f110733db9bdf0643879.woff";